<template>
  <b-card @click="emitClick" no-body="" class="p-1" :class="{'my-1': view === 'list', 'selected' : selected}">
    <b-row>
      <!-- image if file -->
      <b-col v-if="media.type === 'image' || media.type === 'video'" :cols="view === 'list' ? '4' : '12'">
        <b-card-img :src="media.thumb_url"
        :top="true" :bottom="true" :left="true" :right="true"
         />
      </b-col>
      <!-- image if url -->
      <b-col v-if="media.type === 'url'" :cols="view === 'list' ? '4' : '12'">
        <b-embed type="iframe" :src="media.path" style="height:400">
        </b-embed>
      </b-col>
      <!-- name and icon if folder -->
      <b-col :cols="view === 'list' ? (type === 'file' ? '4' : '8') : '12'">
        <b-card-text class="px-2 py-2 mt-1">
          <fa-icon class="folder-icon" v-if="type === 'folder'" icon="folder-open" size="lg"></fa-icon>
          <b-input @click.stop v-if="rename" v-model="newName" size="sm"></b-input>
          <span v-if="!rename">{{media.name}}</span>
        </b-card-text>
      </b-col>
      <!-- action buttons -->
      <b-col :cols="view === 'list' ? '4' : '12'">
        <b-card-text class="px-2 py-2 m-0">
          <div class="d-flex justify-content-end align-items-center" v-if="showButtons && !rename">
            <b-button :disabled="isBusy" variant="info" class="ml-1" size="sm" @click.stop="$emit('move-clicked', {media, type})">Move</b-button>
            <b-button :disabled="isBusy" variant="primary" class="ml-1" size="sm" @click.stop="rename = true; newName = media.name">Rename</b-button>
            <b-button :disabled="isBusy" variant="warning" class="ml-1" size="sm" @click.stop="$emit('change-clicked', {media, type})" v-if="type === 'file'">Change</b-button>
            <b-button :disabled="isBusy" variant="danger" class="ml-1" size="sm" @click.stop="$emit('delete-clicked', {media, type})">Delete</b-button>
          </div>
          <div class="d-flex justify-content-end" v-if="showButtons && rename">
            <b-button :disabled="isBusy" variant="primary" class="ml-1" size="sm" @click.stop="rename = false; $emit('rename-clicked', {media, type, newName})">Update</b-button>
            <b-button :disabled="isBusy" variant="danger" class="ml-1" size="sm" @click.stop="rename = false;">Cancel</b-button>
          </div>
        </b-card-text>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  props: {
    media: {
      type: [Object],
      required: true,
    },
    type: {
      type: [String],
      required: true,
    },
    showButtons: {
      type: [Boolean],
      required: false,
      default: true,
    },
    isBusy: {
      type: [Boolean],
      required: false,
      default: false,
    },
    view: {
      type: [String],
      required: false,
      default: 'grid',
    },
    selected: {
      type: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      rename: false,
      newName: '',
    };
  },
  computed: {
    getThumbnail(file) {
      if (file.thumb_url && file.thumb_url.length) {
        return file.thumb_url;
      }
      if (file.mime_type.toLowerCase().indexOf('image') >= 0) {
        return (`/storage/${file.path}/${file.real_name}`);
      }

      return '';
    },
  },
  methods: {
    emitClick() {
      if (!this.isBusy && !this.rename) {
        this.$emit('card-clicked', { media: this.media, type: this.type });
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .card{
    .folder-icon{
      margin-right: 4px;
    }
    cursor: pointer;
  }

  .selected {
    background-color: black;
    color: white;
  }
</style>
